import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useListingAuth } from '@/contexts/ListingAuthContext.jsx';
import SEO from '@/components/SEO';

function ListingProtectedRoute({ children }) {
  const { isAuthenticated } = useListingAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    return (
      <>
        <SEO
          title="Login Required | OmNivaas Properties"
          description="This private OmNivaas owner or tenant page requires secure login."
          path={location.pathname}
          robots="noindex,nofollow"
        />
        {typeof window !== 'undefined' && (
          <Navigate to="/login" state={{ from: location }} replace />
        )}
      </>
    );
  }

  return children;
}

export default ListingProtectedRoute;
